import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  FormContainer,
  FormHeader,
  FormField,
  SubmitButton,
  Message
} from "./VincularGravidezForm.styles";
import api from "../../services/api";

const VincularGravidezForm = ({ gestante, onClose, gestacao, onGravidezVinculada }) => {
  const [formValues, setFormValues] = useState({
    gestante_cpf: gestante.cpf || "",
    dum: "",
    qtd_filhos: 0,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [ultimaDum, setUltimaDum] = useState(null);
  const [hasActiveGravidez, setHasActiveGravidez] = useState(false);

  useEffect(() => {
    const fetchUltimaGravidez = async () => {
      try {
        const response = await api.get(`/gestante/${gestante.cpf}/consultas`);
        const gravidezes = response.data;

        const gravidezesAtivas = gravidezes.filter(g => !g.data_fim || g.status_gravidez === "Em Andamento");
        setHasActiveGravidez(gravidezesAtivas.length > 0);
        
        if (gravidezes.length > 0){
          const gravidezesEncerradas = gravidezes.filter(g => g.data_fim);
          if (gravidezesEncerradas.length > 0) {
            const maisRecente = gravidezesEncerradas.sort(
              (a, b) => new Date(b.data_fim) - new Date(a.data_fim)
            )[0];
            const [dia, mes, ano] = maisRecente.data_fim.split("/");
            const dataFormatada = new Date(`${ano}-${mes}-${dia}`);
            setUltimaDum(dataFormatada);
          }
        }

      } catch (error) {
        const errorDetail = error.response?.data?.detail || "Erro ao obter gestações"
        setErrorMessage(errorDetail)
      }
    }

    fetchUltimaGravidez();
  }, [gestacao])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    const novaDum = new Date(formValues.dum);
    if (hasActiveGravidez || (ultimaDum && (novaDum - ultimaDum) / (1000 * 60 * 60 * 24) < 60)) {
      setErrorMessage("Só será permitido inserir uma nova gestação após 60 dias do encerramento da gestação anterior.");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await api.post("/gestante/gravidez", formValues);

      if (response.status === 201) {
        setSuccessMessage("Gestação vinculada com sucesso!");
        
        // Chama o callback para atualizar a lista
        if (onGravidezVinculada) {
          onGravidezVinculada();
        }
        
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        const errorData = response.data;
        setErrorMessage(errorData.detail || "Erro ao vincular gestação.");
      }
    } catch (error) {
      const errorDetail = error.response?.data?.detail || "Erro de conexão com o servidor.";
      setErrorMessage(errorDetail);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
    
    <FormContainer>
      <FormHeader>Vincular Gestação</FormHeader>
      <form onSubmit={handleSubmit}>
        <FormField>
          <label>CPF da Gestante:</label>
          <input type="text" value={formValues.gestante_cpf} disabled />
        </FormField>

        <FormField>
          <label>Data da Última Menstruação (DUM):</label>
          <input
            type="date"
            name="dum"
            value={formValues.dum}
            onChange={handleChange}
            required
          />
        </FormField>

        <FormField>
          <label>Quantidade de Filhos da Gestação:</label>
          <input
            type="number"
            name="qtd_filhos"
            value={formValues.qtd_filhos}
            onChange={handleChange}
            min="0"
            required
          />
        </FormField>

        <SubmitButton type="submit" disabled={hasActiveGravidez || isSubmitting} title={hasActiveGravidez ? "Já existe uma gestação em andamento" : ""} >
          {isSubmitting ? "Vinculando..." : "Vincular"}
        </SubmitButton>
      </form>

      {successMessage && <Message>{successMessage}</Message>}
      {errorMessage && <Message isError>{errorMessage}</Message>}
    </FormContainer>
    </>
  );
};

VincularGravidezForm.propTypes = {
  gestante: PropTypes.object.isRequired,
  gestacao: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onGravidezVinculada: PropTypes.func,
};

export default VincularGravidezForm;
